import React from 'react'
import '../css/Admissions.css'
import Admission from '../images/Application.pdf'
const Admissions = () => {
  return (
    <div className="admissionContainer">
        <div className="admissionArea">
        <h1 className="minititle">입 학 안 내</h1>
           <div className="innerList">
             <h1>제 출 서 류</h1>
             <ul>
                <li>입학원서 1부 (본교 소정양식)</li>
                <li>신앙고백서 1부</li>
                <li>목사 추천서 1부</li>
                <li>명함판 사진 2매</li>
                <li>최종학교 졸업 증명서 1부</li>
                <li>최종학교 성적 증명서 1부</li>
                <li>영성 훈련 및 전도훈련 학점 가산</li>
             </ul>
             <p>봄학기 2월 25일 마감</p>
             <p>가을학기 8월 25일 마감</p>
           </div>   
        <h1 className="minititle">입학원서</h1>
        <a href={Admission} download>
            <button>Download Application (입학원서)</button>
        </a>
        <ol>
            <li>Download the PDF Application Form
(입학원서를 클릭하세요)</li>
<li>Open the PDF Application Form
(왼쪽아래 PDF Form탭을 클릭 하시면 다운로드가 됩니다.)</li>
<li>Print the PDF Application Form
(다운로드가 된 원서를 프린트 하셔서 작성 하신후 제출해 주세요.)</li>
<li>Fill out the printed PDF Application Form</li>
<li>작성된 원서는 아래 주소로 보내 주세요.</li>
        </ol>
        <p>|NY Campus|<br/>
              188-12 73rd Avenue, Fresh Meadows, NY 11366<br/>
            |Boston Campus|<br/>
             50 Quincy Street, Cambridge, MA 02138</p>
        <p>총무처: (908)553-8400<br/>
                              대표:(718)310-7062 <br/>
                              E-mail: yikim3535@gmail</p>
        </div>
    </div>
  )
}

export default Admissions